import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { backendApi } from "../backendApi/backendApi";

export const Route = createFileRoute("/gs-admin")({
  component: Outlet,
  beforeLoad: async ({ location, context: { auth } }) => {
    /**
     * TODO: in the future we should make sure that either the route is /login OR
     * the logged in user has .account.account_type == "GREENSHIELD_ADMIN" (redirect if not GS)
     */
    const isOnLoginPage = location.pathname === "/login";

    if (!isOnLoginPage) {
      if (!(await auth.verifyAuth())) {
        throw redirect({
          to: "/login",
          search: {
            // Use the current location to power a redirect after login
            // (Do not use `router.state.resolvedLocation` as it can
            // potentially lag behind the actual current location)
            // redirect: location.href,
          },
        });
      }
    } else if (isOnLoginPage && backendApi.checkTokens()) {
      throw redirect({
        to: "/gs-admin/members/enroll",
      });
    }
  },
});
